export default "__VITE_ASSET__ca8f2901__"